module.exports = __webpack_public_path__ + "img/image-47.462b713a.png";